import React from 'react';
import { Instagram, MessageCircle, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/5 bg-background py-12 relative z-10" data-id="element-126">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-127">
        <div className="flex flex-col items-center md:items-start" data-id="element-128">
          <a href="#" className="text-2xl font-bold tracking-tighter text-white mb-2" data-id="element-129">
            Website
            <span className="text-gradient bg-gradient-to-r from-electric to-cyan" data-id="element-130">
              IA
            </span>
          </a>
          <p className="text-sm text-neutral-500" data-id="element-131">
            Webs premium para negocios en LATAM
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-132">
          <a href="https://www.instagram.com/websiteia/?hl=es" target="_blank" rel="noreferrer" className="flex items-center space-x-2 text-neutral-400 hover:text-white transition-colors group" data-id="element-133">
            <Instagram size={18} className="group-hover:text-electric transition-colors" data-id="element-134" />
            <span className="text-sm" data-id="element-135">@websiteia</span>
          </a>
          <a href="https://wa.me/59898838657?text=%C2%A1Hola%21%20Quiero%20activar%20mi%20web%20premium%20con%20WebsiteIA.%20%C2%BFMe%20asesoran%3F" target="_blank" rel="noreferrer" className="flex items-center space-x-2 text-neutral-400 hover:text-white transition-colors group" data-id="element-136">
            <MessageCircle size={18} className="group-hover:text-green-400 transition-colors" data-id="element-137" />
            <span className="text-sm" data-id="element-138">WhatsApp</span>
          </a>
          <a href="mailto:wwwebsiteia@gmail.com" className="flex items-center space-x-2 text-neutral-400 hover:text-white transition-colors group" data-id="element-139">
            <Mail size={18} className="group-hover:text-cyan transition-colors" data-id="element-140" />
            <span className="text-sm" data-id="element-141">wwwebsiteia@gmail.com</span>
          </a>
        </div>

        <div className="text-sm text-neutral-600 text-center md:text-right" data-id="element-142">
          &copy; {new Date().getFullYear()} WebsiteIA.
          <br className="md:hidden" data-id="element-143" /> Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}